import { render } from "./FilmCategory.vue?vue&type=template&id=21c1a284"
import script from "./FilmCategory.vue?vue&type=script&lang=js"
export * from "./FilmCategory.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fanhaipeng/code/giga-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__